__turbopack_context__.v({
  "brand": "Brand-module__P1IB5W__brand",
  "mark": "Brand-module__P1IB5W__mark",
  "wordmark": "Brand-module__P1IB5W__wordmark",
});
